/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_All_ExercisesInputs */

const en_us2_workout_all_exercises = /** @type {(inputs: Workout_All_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See all exercises`)
};

const pt_br2_workout_all_exercises = /** @type {(inputs: Workout_All_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos os exercícios`)
};

const es_419_workout_all_exercises = /** @type {(inputs: Workout_All_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos los ejercicios`)
};

const pt_pt2_workout_all_exercises = /** @type {(inputs: Workout_All_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos os exercícios`)
};

const fr_fr2_workout_all_exercises = /** @type {(inputs: Workout_All_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir tous les exercices`)
};

const de_de2_workout_all_exercises = /** @type {(inputs: Workout_All_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Übungen ansehen`)
};

const it_it2_workout_all_exercises = /** @type {(inputs: Workout_All_ExercisesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi tutti gli esercizi`)
};

/**
* | output |
* | --- |
* | "See all exercises" |
*
* @param {Workout_All_ExercisesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_all_exercises = /** @type {((inputs?: Workout_All_ExercisesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_All_ExercisesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_all_exercises(inputs)
	if (locale === "es-419") return es_419_workout_all_exercises(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_all_exercises(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_all_exercises(inputs)
	if (locale === "de-DE") return de_de2_workout_all_exercises(inputs)
	if (locale === "it-IT") return it_it2_workout_all_exercises(inputs)
	return en_us2_workout_all_exercises(inputs)
});
export { workout_all_exercises as "workout.all_exercises" }